.root {
  display: grid;
  grid-template-rows: repeat(7, 38px);
  grid-template-columns: repeat(7, 38px);
  overflow: hidden;
  vertical-align: middle;
  text-align: center;
  border-radius: 5px;
}
